export default __webpack_public_path__ + "static/media/sombrero-de-paja.c5d6ba7f.png";